const state = () => ({
  loading: false,
});

const mutations = {
  SET_LOADING: (state: any, loading: Boolean) => {
    state.loading = loading;
  },
};

const actions = {
  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },
};
// getters
const getters = {
  loading: (state: any) => state.loading,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
